import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

export const FacetsPanelWrapper = styled.section`
    display: flex;
    flex-direction: column;
    border-radius: ${getPurpurBorder('radiusLg')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
    max-width: 19.875rem;
    background-color: ${getPurpurColor('functionalWhite')};
    overflow: hidden;
`;
